import { fetchLocations } from "../services/PiLocationService";
import Room from "./Room";


export default class FactoryRoomManager {
    private rooms: Room[] = [];

    public async FetchAndCreateRooms() {
        const locations = await fetchLocations();
        locations.find(loc => loc.ElementName === "274")!.Location = "0";
        locations.find(loc => loc.ElementName === "277")!.Location = "0";


        for (const loc of locations) {

            const roomPoints = loc.Location.split(";").map(room => room.trim()).filter(room => room.length > 0);

            for (const roomPoint of roomPoints) {
                let corners: { x: number, z: number }[] = [];

                const xyPairs = roomPoint.split(",").map(coord => parseFloat(coord.trim()));
                if (xyPairs.length < 2) {
                    continue;
                }

                for (let i = 0; i < xyPairs.length; i += 2) {
                    const [x, z] = xyPairs.slice(i, i + 2);
                    corners.push({ x, z: -z }); // Negate z to match expected coordinate system
                }

                if (corners.length < 2) {
                    continue;
                }

                // Detect and insert missing corners for each room
                try {
                    this.rooms.push(new Room(this.generateCorners(corners)));
                } catch (error) {
                    console.error('Error creating room', loc, error);
                    continue;
                }
            }

            // Convert coordinate pairs into objects

        }

        return this.rooms;
    }

    public generateCorners(corners: { x: number, z: number }[]) {
        const completedCorners: { x: number, z: number }[] = [];

        for (let i = 0; i < corners.length; i += 2) {
            const topLeft = corners[i];
            const bottomRight = corners[i + 1];

            // Add the original corners
            completedCorners.push(topLeft, bottomRight);

            // Insert missing corners to form a box
            completedCorners.push({ x: topLeft.x, z: bottomRight.z });
            completedCorners.push({ x: bottomRight.x, z: topLeft.z });
        }

        // Sort corners in counter-clockwise order (around centroid)
        if (completedCorners.length >= 3) {
            const centroid = {
                x: completedCorners.reduce((sum, c) => sum + c.x, 0) / completedCorners.length,
                z: completedCorners.reduce((sum, c) => sum + c.z, 0) / completedCorners.length,
            };

            completedCorners.sort((a, b) => {
                const angleA = Math.atan2(a.z - centroid.z, a.x - centroid.x);
                const angleB = Math.atan2(b.z - centroid.z, b.x - centroid.x);
                return angleA - angleB;
            });
        }

        return completedCorners;
    }

    public getRooms() {
        return this.rooms;
    }
}